import { useEffect } from "react"
import { AppLoader } from "@/components/utils"
import { useAPIResources } from "@/hooks"
import { answersAPI, questionsAPI, setQueryCache } from "@/utils"
import { QuestionsCommonStage } from "./QuestionsCommonStage"
import { QuestionsFeedback } from "./QuestionsFeedback"
import type { IStageProps } from "./types"

export function QuestionsStage(props: IStageProps) {
  // Load questions and answers
  const { usersession, onNext } = props

  const { data: { data: answers = [] } = {}, isPending: isAnswersPending } = useAPIResources(
    answersAPI,
    {
      where: { usersession_id: usersession.id },
    },
    usersession.session.id,
  )
  const { data: { data: questions = [] } = {}, isPending: isQuestionsPending } = useAPIResources(questionsAPI, {
    where: { session_id: usersession.session.id },
    ...setQueryCache(3600e3),
  })

  // Skip the stage if there are no questions
  useEffect(() => {
    if (!isQuestionsPending && !questions.length) onNext()
  }, [questions, onNext, isQuestionsPending])

  if (isQuestionsPending || isAnswersPending) return <AppLoader mih={400} />

  return usersession.session.type == "feedback" ? (
    <QuestionsFeedback answers={answers} questions={questions} {...props} />
  ) : (
    <QuestionsCommonStage answers={answers} questions={questions} {...props} />
  )
}
